import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { useSelector } from "react-redux";
import * as crud from './crud';

//
const initialStandardSlice = {
    listLoading: true,
    actionsLoading: false,
    queryParams: null,
    error: null,
    totalCount: 0,
    entities: [],
    selectedStandard: {},
    versions: [],
    standard: null,
    loading: 'idle'
}

//
export const callTypes = {
    list: 'list',
    select: 'select',
    versions: 'version'
}

//
// Actions
//

export const fetchStandardByIdentifier = createAsyncThunk(
    'standard/featchStandardByIdentifier',
    /**
     * 
     * @param @param {{
     *  identifier: string,
     *  path: string,
     *  odata: Partial<import('odata-query').QueryOptions<any>>
     * }} fetchIdentifers 
     * @returns 
     */
    async (fetchIdentifers) => {
        const response = await crud.fetchStandardByIdentifier(fetchIdentifers);
        return _.first(response.data.value)
    }
);

/**
     *
     * @param @param {{
     *  identifier: string,
     *  path: string,
     *  odata: Partial<import('odata-query').QueryOptions<any>>
     * }} fetchIdentifers
     * @returns
     */
export const fetchStandard = async (fetchIdentifers) => {
    const response = await crud.fetchStandardByIdentifier(fetchIdentifers);
    return _.first(response.data.value)
}

//
// Slice
//
export const standardSlice = createSlice({
    name: 'standard',
    initialState: initialStandardSlice,
    reducers: {
        //
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list || action.payload.callType === callTypes.select) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        //
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list || action.payload.callType === callTypes.select) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        //
        standardFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },

        standardSelected: (state, action) => {
            state.listLoading = false;
            state.error = null;
        },

        standardVersionsFetched: (state, action) => {
            const { value } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.versions = value;
        }
    },
    extraReducers: (build) => {
        build.addCase(fetchStandardByIdentifier.pending, ( state, action ) => {
            if ( state.loading === 'idle' ) {
                state.loading = 'loading'
            }
        }).addCase(fetchStandardByIdentifier.fulfilled, ( state, action) => {
            if ( state.loading === 'loading' ) {
                state.standard = action.payload
                state.loading = 'idle'
            }
        }).addCase(fetchStandardByIdentifier.rejected, ( state, action ) => {
            if ( state.loading === 'loading' ) {
                state.loading = 'idle'
                state.error = 'Erro ao carregar'
            }
        })
    }
})

export const useStandard = () => useSelector(( state ) => state.standard );